/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIProduct } from '@/models/api/product.model'

const resource = {
    main: 'services',
    module: 'products'
}

export class ProductsServices {
    public static getProducts () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getProductsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getProductsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createProducts (params: APIProduct) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editProducts (params: APIProduct) {
        return service.put(`${resource.main}/${resource.module}/${params.productId}`, params)
    }

    public static deleteProducts (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreProducts (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
